import axios from "axios";

export const getTransaction = id => {
    return axios.get(`transaction/${id}`)
}